import { connect } from 'react-redux';
import Extrato from './extrato';

export default connect()(Extrato);
